function waitForElement(querySelector, timeout){
  return new Promise((resolve, reject)=>{
    var timer = false;
    if(document.querySelector(querySelector)) return resolve();
    const observer = new MutationObserver(()=>{
      if(document.querySelector(querySelector)){
        observer.disconnect();
        if(timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true, 
      subtree: true
    });
    if(timeout) timer = setTimeout(()=>{
      observer.disconnect();
      reject();
    }, timeout);
  });
}

waitForElement("#app-embed", 3000).then(function(){
  const formB2B = document.querySelector("#app-embed");
  if(formB2B!=null){
    let countrySelect = formB2B.shadowRoot.querySelector('button[aria-controls="billing_address_country-selector-dropdown"]');
    countrySelect.disabled = true;
  }
}).catch(()=>{
    //alert("element did not load in 3 seconds");
});